export default __webpack_public_path__ + "static/media/war3-copy.8185fc1c.gif";